import api from '@/api';

class PropertyAssessmentType {
  /**
   * Index / Get listing of assessment types for a property
   * @returns {*}
   */
  static list(propertyId, params) {
    return api.get(`/properties/${propertyId}/assessment-types`, {params});
  }

  /**
   * Add a property assessment type
   * @param params
   * @returns {*}
   */
  static add(propertyId, params) {
    return api.post(`/properties/${propertyId}//assessment-types`, params);
  }

  /**
   * Update a property assessment type
   * @param propertyContactId
   * @param params
   * @returns {*}
   */
  static update(propertyId, params) {
    return api.put(`/properties/${propertyId}/assessment-types`, params);
  }

  /**
   * @returns {string}
   * @constructor
   */
  static COMPLIANCE_TYPE_FIRE() {
    return 'Fire Risk';
  }

  /**
   * @returns {string}
   * @constructor
   */
  static COMPLIANCE_TYPE_FIRE_ID() {
    return 2;
  }

  /**
   * @returns {string}
   * @constructor
   */
  static ASSESSMENT_TYPE_FIRE_RISK_ID() {
    return 8;
  }
}

export default PropertyAssessmentType;
